var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMappingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM7.08349 8.70767C6.67722 7.6882 7.68791 6.67747 8.7074 7.08372L12.7356 8.68888C13.9078 9.15602 14.8461 10.0704 15.3431 11.2303L17.1969 15.5557C17.6414 16.5929 16.5927 17.6415 15.5555 17.197L11.2301 15.3433C10.0703 14.8462 9.15587 13.908 8.68872 12.7358L7.08349 8.70767ZM8.69209 8.69233L10.0822 12.1805C10.4018 12.9825 11.0274 13.6245 11.821 13.9646L15.572 15.5721L13.9644 11.8212C13.6243 11.0276 12.9824 10.4019 12.1803 10.0823L8.69209 8.69233Z",
    fill: "#FFB100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappingActive);
export default __webpack_public_path__ + "static/media/mapping_active.1ad78deaf221e746de396c189d555b5f.svg";
export { ForwardRef as ReactComponent };